import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import HomeEn from "@/pages/home-en/page";
import HomeFr from "@/pages/home-fr/page";
import HomeEs from "@/pages/home-es/page";
import ServicesDe from "@/pages/de/services/page";
import ServicesEn from "@/pages/en/services/page";
import ServicesFr from "@/pages/fr/services/page";
import ServicesEs from "@/pages/es/servicios/page";
import About from "@/pages/about/page";
import AboutEn from "@/pages/about-en/page";
import AboutFr from "@/pages/about-fr/page";
import AboutEs from "@/pages/about-es/page";
import Management from "@/pages/about/management/page";
import CoreValues from "@/pages/about/core-values/page";
import MissionVision from "@/pages/about/mission-vision/page";
import ManagementEn from "@/pages/about-en/management/page";
import CoreValuesEn from "@/pages/about-en/core-values/page";
import MissionVisionEn from "@/pages/about-en/mission-vision/page";
import ManagementFr from "@/pages/about-fr/management/page";
import CoreValuesFr from "@/pages/about-fr/core-values/page";
import MissionVisionFr from "@/pages/about-fr/mission-vision/page";
import ManagementEs from "@/pages/about-es/management/page";
import CoreValuesEs from "@/pages/about-es/core-values/page";
import MissionVisionEs from "@/pages/about-es/mission-vision/page";
import ContactDe from "@/pages/de/contact/page";
import ContactEn from "@/pages/en/contact/page";
import ContactFr from "@/pages/fr/contact/page";
import ContactEs from "@/pages/es/contact/page";
import Privacy from "@/pages/privacy/page";
import PrivacyEn from "@/pages/privacy-en/page";
import PrivacyFr from "@/pages/privacy-fr/page";
import PrivacyEs from "@/pages/privacy-es/page";
import Imprint from "@/pages/imprint/page";
import ImprintEn from "@/pages/imprint-en/page";
import ImprintFr from "@/pages/imprint-fr/page";
import ImprintEs from "@/pages/imprint-es/page";
import StandaloneConsultingDe from "@/pages/de/services/consulting/page";
import StandaloneConsultingServicesEn from "@/pages/en/services/consulting-services/page";
import StandaloneConseilFr from "@/pages/fr/services/conseil/page";
import StandaloneConsultoriaEs from "@/pages/es/servicios/consultoria/page";
import InterimManagementDe from "@/pages/de/services/interim-management/page";
import InterimManagementEn from "@/pages/en/services/interim-management/page";
import ManagementDeTransitionFr from "@/pages/fr/services/management-de-transition/page";
import InterimManagementEs from "@/pages/es/servicios/interim-management/page";
import TrainingCoachingDe from "@/pages/de/services/training-coaching/page";
import TrainingCoachingEn from "@/pages/en/services/training-coaching/page";
import FormationEtCoachingFr from "@/pages/fr/services/formation-et-coaching/page";
import FormacionYCoachingEs from "@/pages/es/servicios/formacion-y-coaching/page";
import ProduktmanagementDe from "@/pages/de/services/business-development/produktmanagement/page";
import ProductManagementEn from "@/pages/en/services/business-development/product-management/page";
import GestionDeProduitsFr from "@/pages/fr/services/developpement-commercial/gestion-de-produits/page";
import GestionDeProductosEs from "@/pages/es/servicios/desarrollo-de-negocio/gestion-de-productos/page";
import ProjektmanagementDe from "@/pages/de/services/business-development/projektmanagement/page";
import ProjectManagementEn from "@/pages/en/services/business-development/project-management/page";
import GestionDeProjetsFr from "@/pages/fr/services/developpement-commercial/gestion-de-projets/page";
import GestionDeProyectosEs from "@/pages/es/servicios/desarrollo-de-negocio/gestion-de-proyectos/page";
import MarktanalysenDe from "@/pages/de/services/business-development/marktanalysen/page";
import MarketResearchEn from "@/pages/en/services/business-development/market-research/page";
import AnalysesDeMarcheFr from "@/pages/fr/services/developpement-commercial/analyses-de-marche/page";
import AnalisisDeMercadoEs from "@/pages/es/servicios/desarrollo-de-negocio/analisis-de-mercado/page";
import MarkteintrittDe from "@/pages/de/services/business-development/markteintritt/page";
import MarketEntryStrategiesEn from "@/pages/en/services/business-development/market-entry-strategies/page";
import StrategiesEntreeMarcheFr from "@/pages/fr/services/developpement-commercial/strategies-entree-marche/page";
import EstrategiasEntradaMercadoEs from "@/pages/es/servicios/desarrollo-de-negocio/estrategias-entrada-mercado/page";
import ImportmanagementDe from "@/pages/de/services/business-development/importmanagement/page";
import ImportManagementEn from "@/pages/en/services/business-development/import-management/page";
import GestionDesImportationsFr from "@/pages/fr/services/developpement-commercial/gestion-des-importations/page";
import GestionDeImportacionesEs from "@/pages/es/servicios/desarrollo-de-negocio/gestion-de-importaciones/page";
import InternationalerHandelDe from "@/pages/de/services/business-development/internationaler-handel/page";
import InternationalTradeEn from "@/pages/en/services/business-development/international-trade/page";
import CommerceInternationalFr from "@/pages/fr/services/developpement-commercial/commerce-international/page";
import ComercioInternacionalEs from "@/pages/es/servicios/desarrollo-de-negocio/comercio-internacional/page";
import TechnischerSupportDe from "@/pages/de/services/business-development/technischer-support/page";
import TechnicalSupportEn from "@/pages/en/services/business-development/technical-support/page";
import SupportTechniqueFr from "@/pages/fr/services/developpement-commercial/support-technique/page";
import SoporteTecnicoEs from "@/pages/es/servicios/desarrollo-de-negocio/soporte-tecnico/page";
import Partnership from "@/pages/partnership/page";
import PartnershipEn from "@/pages/partnership-en/page";
import PartnershipFr from "@/pages/partenariat/page";
import PartnershipEs from "@/pages/colaboracion/page";
import BusinessDevelopmentDe from "@/pages/de/services/business-development/page";
import BusinessDevelopmentEn from "@/pages/en/services/business-development/page";
import BusinessDevelopmentFr from "@/pages/fr/services/developpement-commercial/page";
import BusinessDevelopmentEs from "@/pages/es/servicios/desarrollo-de-negocio/page";
import GeschaeftspraesenzDe from "@/pages/de/services/business-development/geschaeftspraesenz/page";
import BusinessPresenceEn from "@/pages/en/services/business-development/business-presence/page";
import PresenceCommercialeFr from "@/pages/fr/services/developpement-commercial/presence-commerciale/page";
import PresenciaEmpresarialEs from "@/pages/es/servicios/desarrollo-de-negocio/presencia-empresarial/page";
import FullServiceAngebotDe from "@/pages/de/services/business-development/full-service-angebot/page";
import FullServicePackageEn from "@/pages/en/services/business-development/full-service-offer/page";
import OffreCompleteFr from "@/pages/fr/services/developpement-commercial/offre-complete/page";
import ServicioCompletoEs from "@/pages/es/servicios/desarrollo-de-negocio/paquete-de-servicio-completo/page";
import ConsultingDe from "@/pages/de/services/business-development/consulting/page";
import ConsultingServicesEn from "@/pages/en/services/business-development/consulting-services/page";
import ConseilFr from "@/pages/fr/services/developpement-commercial/conseil/page";
import ConsultoriaEs from "@/pages/es/servicios/desarrollo-de-negocio/consultoria/page";
import LanguageRedirect from "@/components/feature/LanguageRedirect";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LanguageRedirect />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/en",
    element: <HomeEn />,
  },
  {
    path: "/fr",
    element: <HomeFr />,
  },
  {
    path: "/es",
    element: <HomeEs />,
  },
  // === Services Overview (language-prefixed) ===
  {
    path: "/de/services",
    element: <ServicesDe />,
  },
  {
    path: "/en/services",
    element: <ServicesEn />,
  },
  {
    path: "/fr/services",
    element: <ServicesFr />,
  },
  {
    path: "/es/servicios",
    element: <ServicesEs />,
  },
  // === Contact (language-prefixed) ===
  {
    path: "/de/kontakt",
    element: <ContactDe />,
  },
  {
    path: "/en/contact",
    element: <ContactEn />,
  },
  {
    path: "/fr/contact",
    element: <ContactFr />,
  },
  {
    path: "/es/contacto",
    element: <ContactEs />,
  },
  // === Privacy (language-prefixed) ===
  {
    path: "/de/datenschutz",
    element: <Privacy />,
  },
  {
    path: "/en/privacy",
    element: <PrivacyEn />,
  },
  {
    path: "/fr/politique-de-confidentialite",
    element: <PrivacyFr />,
  },
  {
    path: "/es/politica-de-privacidad",
    element: <PrivacyEs />,
  },
  // === Imprint (language-prefixed) ===
  {
    path: "/de/impressum",
    element: <Imprint />,
  },
  {
    path: "/en/legal-notice",
    element: <ImprintEn />,
  },
  {
    path: "/fr/mentions-legales",
    element: <ImprintFr />,
  },
  {
    path: "/es/aviso-legal",
    element: <ImprintEs />,
  },
  // === About (language-prefixed) ===
  {
    path: "/de/ueber-uns",
    element: <About />,
  },
  {
    path: "/de/ueber-uns/management",
    element: <Management />,
  },
  {
    path: "/de/ueber-uns/grundwerte",
    element: <CoreValues />,
  },
  {
    path: "/de/ueber-uns/mission-vision",
    element: <MissionVision />,
  },
  {
    path: "/en/about-us",
    element: <AboutEn />,
  },
  {
    path: "/en/about-us/management",
    element: <ManagementEn />,
  },
  {
    path: "/en/about-us/core-values",
    element: <CoreValuesEn />,
  },
  {
    path: "/en/about-us/mission-vision",
    element: <MissionVisionEn />,
  },
  {
    path: "/fr/a-propos",
    element: <AboutFr />,
  },
  {
    path: "/fr/a-propos/direction",
    element: <ManagementFr />,
  },
  {
    path: "/fr/a-propos/valeurs-fondamentales",
    element: <CoreValuesFr />,
  },
  {
    path: "/fr/a-propos/mission-vision",
    element: <MissionVisionFr />,
  },
  {
    path: "/es/sobre-nosotros",
    element: <AboutEs />,
  },
  {
    path: "/es/sobre-nosotros/direccion",
    element: <ManagementEs />,
  },
  {
    path: "/es/sobre-nosotros/valores-fundamentales",
    element: <CoreValuesEs />,
  },
  {
    path: "/es/sobre-nosotros/mision-vision",
    element: <MissionVisionEs />,
  },
  // === Partnership (language-prefixed) ===
  {
    path: "/de/partnerschaft",
    element: <Partnership />,
  },
  {
    path: "/en/partnership",
    element: <PartnershipEn />,
  },
  {
    path: "/fr/partenariat",
    element: <PartnershipFr />,
  },
  {
    path: "/es/colaboracion",
    element: <PartnershipEs />,
  },
  // === Consulting Pages (language-prefixed) ===
  {
    path: "/de/services/consulting",
    element: <StandaloneConsultingDe />,
  },
  {
    path: "/en/services/consulting-services",
    element: <StandaloneConsultingServicesEn />,
  },
  {
    path: "/fr/services/conseil",
    element: <StandaloneConseilFr />,
  },
  {
    path: "/es/servicios/consultoria",
    element: <StandaloneConsultoriaEs />,
  },
  // === Interim Management (language-prefixed) ===
  {
    path: "/de/services/interim-management",
    element: <InterimManagementDe />,
  },
  {
    path: "/en/services/interim-management",
    element: <InterimManagementEn />,
  },
  {
    path: "/fr/services/management-de-transition",
    element: <ManagementDeTransitionFr />,
  },
  {
    path: "/es/servicios/interim-management",
    element: <InterimManagementEs />,
  },
  // === Training & Coaching (language-prefixed) ===
  {
    path: "/de/services/training-coaching",
    element: <TrainingCoachingDe />,
  },
  {
    path: "/en/services/training-coaching",
    element: <TrainingCoachingEn />,
  },
  {
    path: "/fr/services/formation-et-coaching",
    element: <FormationEtCoachingFr />,
  },
  {
    path: "/es/servicios/formacion-y-coaching",
    element: <FormacionYCoachingEs />,
  },
  // === DE Business Development Pages ===
  {
    path: "/de/services/business-development",
    element: <BusinessDevelopmentDe />,
  },
  {
    path: "/de/services/business-development/geschaeftspraesenz",
    element: <GeschaeftspraesenzDe />,
  },
  {
    path: "/de/services/business-development/full-service-angebot",
    element: <FullServiceAngebotDe />,
  },
  {
    path: "/de/services/business-development/consulting",
    element: <ConsultingDe />,
  },
  {
    path: "/de/services/business-development/produktmanagement",
    element: <ProduktmanagementDe />,
  },
  {
    path: "/de/services/business-development/projektmanagement",
    element: <ProjektmanagementDe />,
  },
  {
    path: "/de/services/business-development/marktanalysen",
    element: <MarktanalysenDe />,
  },
  {
    path: "/de/services/business-development/markteintritt",
    element: <MarkteintrittDe />,
  },
  {
    path: "/de/services/business-development/importmanagement",
    element: <ImportmanagementDe />,
  },
  {
    path: "/de/services/business-development/internationaler-handel",
    element: <InternationalerHandelDe />,
  },
  {
    path: "/de/services/business-development/technischer-support",
    element: <TechnischerSupportDe />,
  },
  // === EN Business Development Pages ===
  {
    path: "/en/services/business-development",
    element: <BusinessDevelopmentEn />,
  },
  {
    path: "/en/services/business-development/business-presence",
    element: <BusinessPresenceEn />,
  },
  {
    path: "/en/services/business-development/full-service-offer",
    element: <FullServicePackageEn />,
  },
  {
    path: "/en/services/business-development/consulting-services",
    element: <ConsultingServicesEn />,
  },
  {
    path: "/en/services/business-development/product-management",
    element: <ProductManagementEn />,
  },
  {
    path: "/en/services/business-development/project-management",
    element: <ProjectManagementEn />,
  },
  {
    path: "/en/services/business-development/market-research",
    element: <MarketResearchEn />,
  },
  {
    path: "/en/services/business-development/market-entry-strategies",
    element: <MarketEntryStrategiesEn />,
  },
  {
    path: "/en/services/business-development/import-management",
    element: <ImportManagementEn />,
  },
  {
    path: "/en/services/business-development/international-trade",
    element: <InternationalTradeEn />,
  },
  {
    path: "/en/services/business-development/technical-support",
    element: <TechnicalSupportEn />,
  },
  // === FR Business Development Pages ===
  {
    path: "/fr/services/developpement-commercial",
    element: <BusinessDevelopmentFr />,
  },
  {
    path: "/fr/services/developpement-commercial/presence-commerciale",
    element: <PresenceCommercialeFr />,
  },
  {
    path: "/fr/services/developpement-commercial/offre-complete",
    element: <OffreCompleteFr />,
  },
  {
    path: "/fr/services/developpement-commercial/conseil",
    element: <ConseilFr />,
  },
  {
    path: "/fr/services/developpement-commercial/gestion-de-produits",
    element: <GestionDeProduitsFr />,
  },
  {
    path: "/fr/services/developpement-commercial/gestion-de-projets",
    element: <GestionDeProjetsFr />,
  },
  {
    path: "/fr/services/developpement-commercial/analyses-de-marche",
    element: <AnalysesDeMarcheFr />,
  },
  {
    path: "/fr/services/developpement-commercial/strategies-entree-marche",
    element: <StrategiesEntreeMarcheFr />,
  },
  {
    path: "/fr/services/developpement-commercial/gestion-des-importations",
    element: <GestionDesImportationsFr />,
  },
  {
    path: "/fr/services/developpement-commercial/commerce-international",
    element: <CommerceInternationalFr />,
  },
  {
    path: "/fr/services/developpement-commercial/support-technique",
    element: <SupportTechniqueFr />,
  },
  // === ES Business Development Pages ===
  {
    path: "/es/servicios/desarrollo-de-negocio",
    element: <BusinessDevelopmentEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/presencia-empresarial",
    element: <PresenciaEmpresarialEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/paquete-de-servicio-completo",
    element: <ServicioCompletoEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/consultoria",
    element: <ConsultoriaEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/gestion-de-productos",
    element: <GestionDeProductosEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/gestion-de-proyectos",
    element: <GestionDeProyectosEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/analisis-de-mercado",
    element: <AnalisisDeMercadoEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/estrategias-entrada-mercado",
    element: <EstrategiasEntradaMercadoEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/gestion-de-importaciones",
    element: <GestionDeImportacionesEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/comercio-internacional",
    element: <ComercioInternacionalEs />,
  },
  {
    path: "/es/servicios/desarrollo-de-negocio/soporte-tecnico",
    element: <SoporteTecnicoEs />,
  },
  // === 404 ===
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;